import {StrainImageModel} from "@app/strain/common/models/view-measurement-models/strain-image.model";
import { StrainMeasurementGageDetailsModel } from "./strain-measurement-gage-details.model";

export class StrainMeasurementImage {
    public frontSideImage: StrainImageModel;
    public backSideImage: StrainImageModel;
    public observations: string;
    public gages: StrainMeasurementGageDetailsModel[];

    constructor(entry: any = {}) {
        this.observations = entry.observations;
        this.backSideImage = entry.backSideImage ? new StrainImageModel(entry.backSideImage) : null;
        this.frontSideImage = entry.frontSideImage ? new StrainImageModel(entry.frontSideImage) : null;
        this.gages = entry.gages ? entry.gages.map(item => new StrainMeasurementGageDetailsModel(item)) : [];
    }
}
